export default "__VITE_ASSET__B7N$p5U3__"